define('controllers/exhibition/view',[
	'jquery',
	'widgets/emails',
	'widgets/track',
	'widgets/size',
	'widgets/forward',
], function ($) {

	var view = {

		container: '#exhibition > .current',

		id: 'exhibition-view',
		ready: false,
		enabled: null,

		setup: function () {

			if (this.ready) return this;

			this.update();

			this.ready = true;
			return this;

		},

		enable: function () {

			if (this.enabled) return this;

			this.$el.addClass('enabled');

			this.$win = $(window)
				.on('keydown.exhibition-view', $.proxy(this, 'onKeyDown'));

			this.enabled = true;
			return this;

		},

		disable: function () {

			if (!this.enabled) return this;

			this.$el.off('.' + this.id);
			$.unsubscribe('.' + this.id);
			this.$win.off('.exhibition-view');

			this.$el.removeClass('enabled');

			this.enabled = false;
			return this;

		},

		update: function () {

			var $el = $('#' + this.id);

			if (this.$el && this.$el[0] == $el[0])
				return;

			this.$el = $el;

		},

		onKeyDown: function (e) {

			switch (e.keyCode) {

				case 27:
					this.$el.find('.back').trigger('click');
					break;

			}

		}

	};

	return view;

});
